import"./tggTheme.css.ts.vanilla.css";var e="tggTheme_tggTheme__n2hp860";export{e as tggTheme};
//# sourceMappingURL=tggTheme.css.vanilla.js.map
